// extracted by mini-css-extract-plugin
export var banner = "CookieBanner-module--banner--8b35c";
export var banner__btn = "CookieBanner-module--banner__btn--2518c";
export var banner__btnText = "CookieBanner-module--banner__btnText--59f23";
export var banner__btnText___white = "CookieBanner-module--banner__btnText___white--d0444";
export var banner__btnWrapper = "CookieBanner-module--banner__btnWrapper--7166a";
export var banner__btn___white = "CookieBanner-module--banner__btn___white--3c15d";
export var banner__link = "CookieBanner-module--banner__link--d2528";
export var banner__textWrapper = "CookieBanner-module--banner__textWrapper--f761c";